module.exports = __webpack_public_path__ + "img/xmasParty1.5ce3910d.jpg";